"use client";

import { formatShortDateWithPreferences } from "@workspace/shared-utils";
import type { ShowSearchResult } from "@workspace/types";
import { cn } from "@workspace/ui/lib/utils";
import Image from "next/image";
import { useUserPreferences } from "@/hooks/shared/use-user-preferences";

export interface ShowResultProps {
	show: ShowSearchResult;
	isSelected: boolean;
	onSelect: () => void;
}

export function ShowResult({ show, isSelected, onSelect }: ShowResultProps) {
	const userPreferences = useUserPreferences();

	// Get image URL with fallback logic
	const imageUrl = show.poster_url || show.main_artist_image_url;

	return (
		<button
			type="button"
			className={cn(
				"relative flex w-full items-center gap-3 rounded-lg p-3 text-left transition-colors",
				isSelected ? "bg-muted" : "hover:bg-muted",
			)}
			onClick={onSelect}
		>
			{/* Show poster or artist image fallback */}
			<div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-muted">
				{imageUrl ? (
					<Image
						src={imageUrl}
						alt={show.name}
						width={40}
						height={40}
						className="h-10 w-10 rounded-md object-cover"
					/>
				) : (
					<div className="h-10 w-10 rounded-md bg-gradient-to-br from-primary/20 to-primary/5" />
				)}
			</div>

			{/* Show details */}
			<div className="flex min-w-0 flex-1 flex-col">
				<span className="truncate font-medium text-sm">{show.name}</span>
				<span className="truncate text-muted-foreground text-xs">
					{show.venue_obj?.name || "Venue: TBD"} • {show.location || "Location: TBA"}
				</span>
				<span className="text-muted-foreground text-xs">
					{formatShortDateWithPreferences(show.date, userPreferences)}
				</span>
			</div>
		</button>
	);
}
